module.exports = __webpack_public_path__ + "lazerImage.png?e1d04760c4e2f560497b352bc5b5e23c";